import { useNavigate } from 'react-router-dom';
import { GovIcon } from '@gov-design-system-ce/react';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { useDataBoxMessageFormContext } from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import { Button } from '@gov-nx/ui/web';
import { pageRouteResolver } from '@gov-nx/web';
import { DataBoxMessageForm } from './DataBoxMessageForm';

export const DataBoxNewMessagePage = () => {
	const { dataBoxId, folderType } = useDataBoxMessageFormContext();
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(PageCode['datove-schranky']);
	const navigate = useNavigate();

	return (
		<section className="overflow-hidden flex flex-col w-full mt-0! px-(--templates-margin-l) pb-(--templates-margin-l) relative z-200 h-screen bg-(--background-block-primary) [ ds:grow ds:rounded-3xl ds:overflow-hidden ds:h-full ds:z-0 ]">
			<div className="flex items-center justify-between h-(--height-5xl) mt-0!">
				<h2 className="text-body-xl-bold!">{tn('nova-zprava.nadpis')}</h2>
				<Button
					onClick={() =>
						navigate(
							pageRouteResolver('datove-schranky.schranka', {
								dataBoxId,
								folderType,
							})
						)
					}
					className="[ ds:hidden! ]"
					aria-label={tn('nova-zprava.zahodit')}
					type="base"
					size="s"
					nativeType="button"
					color="primary"
					iconStart={
						<GovIcon
							name="x-lg"
							type="components"
						/>
					}
				/>
			</div>
			<div className="flex h-full mt-0! overflow-hidden">
				<DataBoxMessageForm />
			</div>
		</section>
	);
};
